import clsx from "clsx";
import React, { Component } from "react";
import { FormattedMessage } from "react-intl";

import { PATIENT_MAX_FILESIZE } from "~/common/constants";
import { remoteLog } from "~/common/logging";
import FileUpload from "~/components/file_upload";
import { LabelRequiredIndicator } from "~/components/ui/label";
import type { TPatient } from "~/types/patient";

const formatFileName = (filename: string) => {
  const fileName = filename.split("/");
  return fileName[fileName.length - 1];
};

type PatientUpdateFilesProps = {
  patient: TPatient;
  required?: boolean;
  showUploadedFiles?: boolean;
  smartPrescriptionMode?: boolean;
};

type PatientUpdateFilesState = {
  files_counter: number;
};

export class PatientUpdateFiles extends Component<PatientUpdateFilesProps, PatientUpdateFilesState> {
  renders: React.JSX.Element[];

  constructor(props: PatientUpdateFilesProps) {
    super(props);
    this.state = {
      files_counter: 1,
    };
    this.addFileUpload = this.addFileUpload.bind(this);
    this.renders = [this.fileUploadSlot(0)];
  }

  fileUploadSlot(index: number) {
    return (
      <FileUpload
        patient_id={this.props.patient.patient_id}
        onFileUploadEnd={() => this.addFileUpload()}
        key={`recipe_${index}`}
        id={`recipe_${index}`}
        semantics="recipe"
        multiple
        nextBatchId={(offset) => `recipe_${index + offset}`}
        ariaLabelledBy="validation-files"
        maxFileSize={PATIENT_MAX_FILESIZE}
      />
    );
  }

  componentDidCatch(e: Error) {
    remoteLog(e, "patient_update_files");
  }

  addFileUpload() {
    this.renders.push(this.fileUploadSlot(this.renders.length));
    this.forceUpdate();
  }

  render() {
    const filesUploaded = this.props.patient.media && this.props.patient.media.optional_media.length > 0 && this.props.showUploadedFiles;
    const pmo = filesUploaded ? this.props.patient.media.optional_media : [];

    return (
      <div className="form-group">
        <div data-matomo-mask data-hj-suppress className="form-body" id="extra-media-block">
          <h4 className="block" id="validation-files" style={{ fontWeight: "900" }}>
            <FormattedMessage id={this.props.smartPrescriptionMode ? "UPLOAD_FILES_SMART" : "UPLOAD_FILES"} />
            {this.props.required ? <LabelRequiredIndicator /> : null}
          </h4>
        </div>

        <div className="row">
          <div className={clsx("col-xs-4", this.props.smartPrescriptionMode && "patient-smart-files__list")}>{this.renders}</div>
          {filesUploaded ? (
            <div data-matomo-mask data-hj-suppress style={{ marginTop: "12px", width: "100%" }}>
              <h6 style={{ fontWeight: 900 }}>
                <FormattedMessage id="CBCT_UPLOADED_HEADER" />
              </h6>
              <table role="presentation" className="table table-striped clearfix" style={{ wordBreak: "break-all" }} cellSpacing={0} cellPadding={0}>
                <tbody className="files">
                  {pmo.map((m) => (
                    <tr key={m.linkto} className="template-download fade in">
                      <td>
                        <p>{formatFileName(m.linkto)}</p>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}
